import React, { useState } from 'react';
import { ArrowLeft, Check } from 'lucide-react';
import { Button } from '../components/ui/Button';
interface ESIMScreenProps {
  onBack: () => void;
  onPurchase: () => void;
}
export function ESIMScreen({
  onBack,
  onPurchase
}: ESIMScreenProps) {
  const [selectedCountry, setSelectedCountry] = useState('France');
  const [selectedPlan, setSelectedPlan] = useState(2);
  const countries = [{
    name: 'Sénégal',
    flag: '🇸🇳'
  }, {
    name: 'France',
    flag: '🇫🇷'
  }, {
    name: 'EAU',
    flag: '🇦🇪'
  }, {
    name: 'Arabie S.',
    flag: '🇸🇦'
  }, {
    name: 'Europe',
    flag: '🇪🇺'
  }, {
    name: 'USA',
    flag: '🇺🇸'
  }];
  const plans = [{
    id: 1,
    data: '1 Go',
    days: '7 Jours',
    price: '5 000'
  }, {
    id: 2,
    data: '3 Go',
    days: '15 Jours',
    price: '12 000'
  }, {
    id: 3,
    data: '5 Go',
    days: '30 Jours',
    price: '18 000'
  }, {
    id: 4,
    data: '10 Go',
    days: '30 Jours',
    price: '30 000'
  }];
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-177">
      <header className="bg-[#003366] px-6 pt-12 pb-6 sticky top-0 z-10 flex items-center gap-4" data-id="element-178">
        <button onClick={onBack} className="p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-179">
          <ArrowLeft size={24} className="text-white" data-id="element-180" />
        </button>
        <h1 className="text-xl font-bold text-white" data-id="element-181">Acheter une eSIM</h1>
      </header>

      <div className="flex-1 px-6 py-6 space-y-8" data-id="element-182">
        {/* Countries */}
        <div data-id="element-183">
          <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3" data-id="element-184">
            Choisir la destination
          </h3>
          <div className="grid grid-cols-3 gap-3" data-id="element-185">
            {countries.map(country => <button key={country.name} onClick={() => setSelectedCountry(country.name)} className={`p-3 rounded-xl border text-center transition-all ${selectedCountry === country.name ? 'bg-[#D4A017]/10 border-[#D4A017] ring-1 ring-[#D4A017]' : 'bg-white border-gray-200 hover:border-gray-300'}`} data-id="element-186">
                <div className="text-2xl mb-1" data-id="element-187">{country.flag}</div>
                <div className={`text-xs font-medium ${selectedCountry === country.name ? 'text-[#D4A017]' : 'text-gray-700'}`} data-id="element-188">
                  {country.name}
                </div>
              </button>)}
          </div>
        </div>

        {/* Plans */}
        <div data-id="element-189">
          <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3" data-id="element-190">
            Choisir le forfait
          </h3>
          <div className="space-y-3" data-id="element-191">
            {plans.map(plan => <button key={plan.id} onClick={() => setSelectedPlan(plan.id)} className={`w-full flex items-center justify-between p-4 rounded-xl border transition-all ${selectedPlan === plan.id ? 'bg-[#003366] border-[#003366] text-white shadow-lg' : 'bg-white border-gray-200 text-gray-900 hover:border-gray-300'}`} data-id="element-192">
                <div className="text-left" data-id="element-193">
                  <div className="font-bold text-lg" data-id="element-194">{plan.data}</div>
                  <div className={`text-xs ${selectedPlan === plan.id ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-195">
                    Valable {plan.days}
                  </div>
                </div>
                <div className="text-right" data-id="element-196">
                  <div className="font-bold" data-id="element-197">{plan.price} FCFA</div>
                  {selectedPlan === plan.id && <div className="flex justify-end mt-1" data-id="element-198">
                      <div className="bg-[#D4A017] rounded-full p-0.5" data-id="element-199">
                        <Check size={12} className="text-white" data-id="element-200" />
                      </div>
                    </div>}
                </div>
              </button>)}
          </div>
        </div>
      </div>

      <div className="p-6 bg-white border-t border-gray-100 mt-auto" data-id="element-201">
        <div className="flex justify-between items-center mb-4" data-id="element-202">
          <span className="text-gray-500" data-id="element-203">Total</span>
          <span className="text-xl font-bold text-[#003366]" data-id="element-204">
            {plans.find(p => p.id === selectedPlan)?.price} FCFA
          </span>
        </div>
        <Button fullWidth size="lg" onClick={onPurchase} data-id="element-205">
          Acheter maintenant
        </Button>
      </div>
    </div>;
}